import React, { useState } from "react";
import { DatePicker, Form, Select, Spin, Input } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import { RowCol } from "./EmployeeCreateForm";
import { maxValueRule } from "../../../../utils/input";
import { getEntranceTypeOptions, getWorkTypeOptions } from "./functions";

import {
  AREA_SEARCH,
  MANAGER_SEARCH,
  CORPORATION_SEARCH,
  POSITION_SEARCH,
} from "../constants";

export const CompanyForm = ({
  form: addEmployeeForm,
  onFinish,
  formData,
  dispatch,
}) => {
  const [branchCorporations, setBranchCorporations] = useState([]);

  const setBranchOptions = (value) => {
    addEmployeeForm.resetFields(["branch_corporation"]);

    const branches = corporation?.results?.find(
      (corp) => corp.api_url === value,
    )?.branchs_corporation;
    setBranchCorporations(branches);
  };

  const { options: entranceTypeOptions, defaultEntranceType } =
    getEntranceTypeOptions();
  const workTypeOptions = getWorkTypeOptions();

  const { areas, corporation, employees, positions, contractTypes } = formData;

  const contractTypeOptions = contractTypes?.results?.map((contractType) => ({
    key: contractType.id,
    value: contractType.key,
    label: contractType.description,
  }));

  return (
    <Form
      form={addEmployeeForm}
      onFinish={onFinish}
      labelAlign="left"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 12 }}
    >
      <RowCol>
        <FormSearchSelect
          label={"Empresa"}
          name={"corporation"}
          onSelect={setBranchOptions}
          options={corporation?.results.map((corporation) => ({
            key: corporation.id,
            id: corporation.id,
            value: corporation.api_url,
            name: corporation.name,
          }))}
          setSearch={(value) =>
            dispatch({ payload: value, type: CORPORATION_SEARCH })
          }
          isRequired
          requiredMessage={"Por favor insira o campo empresa."}
        />
      </RowCol>
      <RowCol>
        <FormSearchSelect
          label={"Filial"}
          name={"branch_corporation"}
          isSelected={!branchCorporations}
          options={branchCorporations?.map((branch) => ({
            key: branch.id,
            id: branch.id,
            value: branch.api_url,
            name: branch.name,
          }))}
          canRemoveSelectedOption
          setSearch={(value) =>
            branchCorporations.find((branch) => branch.api_url === value)
          }
        />
      </RowCol>
      <RowCol>
        <Form.Item
          label="Data de contratação"
          name="start_date"
          rules={[
            {
              required: true,
              message: "Por favor insira a data de contratação.",
            },
          ]}
        >
          <DatePicker
            locale={locale}
            placeholder={"Selecione a data"}
            format={"DD/MM/YYYY"}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </RowCol>
      <RowCol>
        <Form.Item
          label="Matrícula"
          name="registration_code"
          rules={[maxValueRule(50)]}
        >
          <Input placeholder="Matrícula" />
        </Form.Item>
      </RowCol>
      <RowCol>
        <Form.Item label="Tipo de entrada" name="entrance_type">
          <Select
            placeholder="Tipo"
            options={entranceTypeOptions}
            defaultValue={defaultEntranceType}
          />
        </Form.Item>
      </RowCol>
      <RowCol>
        <Form.Item label="Tipo de contrato" name="contract_type">
          <Select placeholder="Tipo" options={contractTypeOptions} />
        </Form.Item>
      </RowCol>
      <RowCol>
        <Form.Item label="Regime de trabalho" name="work_type">
          <Select placeholder="Regime" options={workTypeOptions} />
        </Form.Item>
      </RowCol>
      <RowCol>
        <FormSearchSelect
          label={"Gestor"}
          name={"manager"}
          options={employees?.results.map((employee) => ({
            id: employee.id,
            value: employee.api_url,
            name: employee.name,
          }))}
          setSearch={(value) =>
            dispatch({ payload: value, type: MANAGER_SEARCH })
          }
        />
      </RowCol>
      <RowCol>
        <FormSearchSelect
          label={"Área"}
          name={"area"}
          options={areas?.results.map((area) => ({
            id: area.id,
            value: area.api_url,
            name: area.name,
          }))}
          setSearch={(value) => dispatch({ payload: value, type: AREA_SEARCH })}
        />
      </RowCol>
      <RowCol>
        <FormSearchSelect
          label={"Cargo"}
          name={"position"}
          options={positions?.results.map((position) => ({
            id: position.id,
            value: position.api_url,
            name: position.name,
          }))}
          setSearch={(value) =>
            dispatch({ payload: value, type: POSITION_SEARCH })
          }
          allowClear
        />
      </RowCol>
    </Form>
  );
};

const FormSearchSelect = ({
  label,
  name,
  options,
  onChange = () => undefined,
  onSelect,
  isRequired = false,
  isSelected = false,
  canRemoveSelectedOption = false,
  requiredMessage = "Por favor preencha o campo",
  isLoading,
  setSearch,
}) => {
  const { Option } = Select;

  return (
    <Form.Item
      label={label}
      name={name}
      rules={[
        {
          required: isRequired,
          message: requiredMessage,
        },
      ]}
    >
      <Select
        placeholder="Selecione"
        showSearch
        onChange={onChange}
        loading={isSelected}
        allowClear={canRemoveSelectedOption}
        filterOption={(input, option) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }
        onSearch={(value) => {
          setSearch(value);
        }}
        onSelect={onSelect}
        notFoundContent={
          isLoading ? <Spin size="small" /> : "Nenhum item encontrado"
        }
      >
        {!isLoading &&
          options &&
          options.map((option, idx) => (
            <Option
              key={option?.key || option?.id || `${option.value}-${idx}`}
              value={option.value}
            >
              {option.name}
            </Option>
          ))}
      </Select>
    </Form.Item>
  );
};
